export const columns = [
  {
    title: '编号',
    customRender: (text, record, index)=>index+1,
  },
  {
    title: '主讲人',
    dataIndex: 'speaker',
  },
  {
    title: '关联推广员',
    dataIndex: 'promoter_list',
    scopedSlots: { customRender: 'promoter_list' },
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '视频',
    dataIndex: 'video_url',
    scopedSlots: { customRender: 'video_url' },
  },

  {
    title: '上传时间',
    dataIndex: 'create_time',

  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
